<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid" style="width: 150vh">
      <div class="card" id="coupanList">
        <div class="card-header border-0">
          <div
            class="d-flex align-items-center justify-content-center text-warning"
            style="text-align: center"
          >
            <h3 v-if="!couponId" class="mb-0 flex-grow-1 text-warning">
              New Coupon
            </h3>
            <h3 v-else class="mb-0 flex-grow-1 text-warning">Edit Coupon</h3>
          </div>
        </div>
        <div
          class="card-body border border-dashed border-end-0 border-start-0"
          style="text-align: left"
        >
          <div class="row g-3">
            <div class="col-lg-12">
              <div>
                <label for="coupan_code" class="form-label"
                  >Coupon Code<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="coupon_code"
                  v-model="v$.couponCode.$model"
                  @blur="v$.couponCode.$touch()"
                  class="form-control"
                  placeholder="Enter Coupon Code"
                  required
                />
                <div class="error-message text-danger">
                  <span v-if="v$.couponCode.$errors.length">
                    {{ v$.couponCode.$errors[0].$message }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <div>
                <label for="coupan_type" class="form-label"
                  >Coupon Type<span style="color: red">*</span></label
                >

                <select
                  v-model="v$.couponType.$model"
                  @blur="v$.couponType.$touch()"
                  class="form-control"
                  name="coupan_type"
                >
                <option value="">Coupon Type</option>
                  <option value="percentage">Percentage</option>
                  <option value="flat">Flat</option>
                </select>
              </div>
            </div>

            <div class="col-lg-12">
              <div>
                <label for="coupan_value" class="form-label"
                  >Valid in Days<span style="color: red">*</span></label
                >
                <input
                  type="number"
                  id="coupan_value"
                  v-model="v$.validDays.$model"
                  @blur="v$.validDays.$touch()"
                  class="form-control"
                  placeholder="Enter Valid Day"
                  required
                />
              </div>
            </div>
            <div class="col-lg-12">
              <div>
                <label for="coupan_value" class="form-label"
                  >Coupon Value<span style="color: red">*</span></label
                >
                <input
                  type="number"
                  id="coupan_value"
                  v-model="v$.couponValue.$model"
                  @blur="v$.couponValue.$touch()"
                  class="form-control"
                  placeholder="Enter Coupon Value"
                  required
                />
                <div class="error-message text-danger">
                  <span v-if="v$.couponValue.$errors.length">
                    {{ v$.couponValue.$errors[0].$message }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <div>
                <label for="coupan_usage" class="form-label"
                  >Minimun Fare
                </label>
                <input
                  type="text"
                  id="coupan_usage"
                  v-model="v$.minimumFare.$model"
                  @blur="v$.minimumFare.$touch()"
                  class="form-control"
                  placeholder="Enter Minimum Fare "
                />
                <div class="error-message text-danger">
                  <span v-if="v$.minimumFare.$errors.length">
                    {{ v$.minimumFare.$errors[0].$message }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="hstack gap-2 justify-content-end mt-2">
                <button
                  style="width: 120px"
                  type="submit"
                  class="btn btn-warning"
                  :class="[
                    'button',
                    { 'btn-disabled': v$.$invalid || loading },
                  ]"
                  @click.prevent="handleSubmit()"
                  :disabled="v$.$invalid || loading"
                >
                  <div
                    v-if="loading"
                    class="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div v-else>
                    <span>{{ couponId ? "Update" : "Create" }}</span>
                  </div>
                </button>
                <button
                  style="width: 120px"
                  type="button"
                  @click="cancel"
                  class="btn border border-warning text-warning"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastNotification ref="toast" />
    </div>
  </div>
</template>

<script>
import { updateCoupan, createCoupan } from "@/apis/coupon";
import { mapState } from "pinia";
import { useAuthStore } from "@/store/auth";
import useVuelidate from "@vuelidate/core";
import { required, numeric, helpers } from "@vuelidate/validators";

export default {
  name: "AppCoupon",
  data() {
    return {
      couponId: null,
      couponCode: null,
      couponType: "",
      couponValue: null,
      minimumFare: null,
      validDays: null,
      status: null,
      loading: false,
      v$: null,
    };
  },

  validations() {
    return {
      couponCode: { required },
      couponType: { required },
      validDays: { required, numeric },

      // Coupon value validation depends on type
      couponValue: {
        required,
        numeric,
        validPercentageOrFlat: helpers.withMessage(
          "If Percentage, value must be between 1 and 100; if Flat, must be greater than 0",
          function (value, vm) {
            if (!value) return false;
            if (vm.couponType === "percentage") {
              return value > 0 && value <= 100;
            } else if (vm.couponType === "flat") {
              return value > 0;
            }
            return true;
          }
        ),
      },

      // Minimum fare validation depends on type
      minimumFare: {
        required,
        numeric,
        validMinFare: helpers.withMessage(
          "For Flat coupons, Minimum Fare must be greater than or equal to Coupon Value",
          function (value, vm) {
            if (vm.couponType === "flat") {
              return Number(value) >= Number(vm.couponValue);
            }
            // For percentage, no strict rule needed
            return true;
          }
        ),
      },
    };
  },

  created() {
    this.v$ = useVuelidate(this.$options.validations, this);
  },

  mounted() {
    const couponData = JSON.parse(localStorage.getItem("user_edit_data"));
    if (couponData) {
      this.couponId = couponData.coupan_id;
      this.couponCode = couponData.coupan_code;
      this.couponType = couponData.coupan_type;
      this.validDays = couponData.valid_day;
      this.minimumFare = couponData.min_fare;
      this.couponValue = couponData.discount_value;
    }
  },

  methods: {
    async handleSubmit() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      const payload = {
        coupan_code: this.couponCode,
        coupan_type: this.couponType,
        discount_value: this.couponValue,
        valid_day: this.validDays,
        min_fare: Number(this.minimumFare),
        created_by: this.ldata.email,
      };

      this.loading = true;
      if (this.couponId) {
        const response = await updateCoupan(this.couponId, payload);
        if (response.success) {
          localStorage.removeItem("user_edit_data");
          this.$refs.toast.showToast("Coupon Updated Successfully", "success");
        } else {
          this.$refs.toast.showToast("Failed to update Coupon", "error");
        }
      } else {
        const response = await createCoupan(payload);
        if (response.success) {
          this.$refs.toast.showToast("Coupon Added Successfully", "success");
        } else {
          this.$refs.toast.showToast("Failed to Add Coupon", "error");
        }
      }
      this.loading = false;

      setTimeout(() => {
        this.cancel();
      }, 2000);
    },

    cancel() {
      this.$router.push("/coupon_and_offers");
    },
  },

  computed: {
    ...mapState(useAuthStore, ["ldata"]),
  },
};
</script>
